module.exports = __webpack_public_path__ + "img/success.a517b2e3.png";